/* import __COLOCATED_TEMPLATE__ from './activity-feed-icon.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { ACTIVITY_FEED_ITEM } from 'sh-www/models/activity-feed-item';

/**
 * This component represents the icon and dropdown for the activity feed
 */
class ActivityFeedIconComponent extends Component {
  @service('state-manager-hybrids/activity-feed-state-manager-hybrid')
  activityFeedStateManager;

  @tracked
  open = false;

  get _constantsActivityFeedTypeApplication() {
    return ACTIVITY_FEED_ITEM.TYPES.APPLICATION;
  }

  get _constantsActivityFeedTypeAssignment() {
    return ACTIVITY_FEED_ITEM.TYPES.ASSIGNMENT;
  }

  get projectDetailsRoute() {
    return EMBER_ROUTE_NAMES.PROJECT__DETAILS;
  }

  get postingRoute() {
    return EMBER_ROUTE_NAMES.POSTING__INDEX;
  }

  get recentActivityFeedItems() {
    return this.activityFeedStateManager.sortedRecentActivityFeedItems;
  }

  get unreadCount() {
    return this.recentActivityFeedItems.filterBy('readAt', null).length;
  }

  @action
  setOpen(isOpen) {
    this.open = isOpen;
  }
}

export default ActivityFeedIconComponent;
